/**
 * 调整图层命令（M2-15）。
 * 参数修改是结构性命令：调整图层没有像素，改的只是参数对象——
 * 非破坏性编辑的全部含义（§4.2）。
 */
import type { Command, Json } from '../command-bus';
import { findLayer } from '../../document/draft';
import type { Adjustment, LayerId } from '../../document/types';

const STRUCTURAL_COST = 256; // 曲线控制点数组略大于普通属性

export function createSetAdjustmentCommand(id: LayerId, adjustment: Adjustment): Command {
  return {
    kind: 'adjustment.set',
    label: '修改调整参数',
    cost: STRUCTURAL_COST,
    // `Adjustment` 没有索引签名，但字段全是纯数据；转换是精确类型，不是 any
    record: { kind: 'adjustment.set', args: { id, adjustment } as unknown as Readonly<Record<string, Json>> },
    apply(draft) {
      draft.updateLayer(id, (layer) =>
        layer.kind === 'adjustment' ? { ...layer, adjustment } : layer,
      );
    },
    invert(document) {
      const layer = findLayer(document.root, id)?.layer;
      if (layer?.kind !== 'adjustment') return null;
      return createSetAdjustmentCommand(id, layer.adjustment);
    },
  };
}
